export enum EInfoProductProvider {
  KIWIFY = 'KIWIFY',
  EVERMART = 'EVERMART',
  HOTMART = 'HOTMART',
  MONETIZZE = 'MONETIZZE',
  PAYT = 'PAYT',
  EDUZZ = 'EDUZZ',
  PERFECT_PAY = 'PERFECT_PAY',
}
